const a = (d = ["__view__"]) => new Promise((r, o) => {
  const t = { decisionScopes: [...d] };
  typeof window.alloy < "u" ? window.alloy("sendEvent", {
    ...t
  }).then(({ propositions: n }) => {
    if (!(n != null && n.length)) {
      r([]);
      return;
    }
    const i = n.filter((e) => t.decisionScopes.includes(e.scope)).flatMap((e) => e.items).map((e) => e.data).filter((e) => e && e.content);
    r(i);
  }).catch(() => {
    o(new Error("Could not retrieve Adobe Target Propositions"));
  }) : o(new Error("Adobe Alloy not defined"));
}), f = (d = "target-global-mbox", r = {}) => new Promise((o, t) => {
  typeof window.adobe < "u" && window.adobe.target ? window.adobe.target.getOffer({
    mbox: d,
    params: r,
    success: (n) => {
      if (Array.isArray(n)) {
        const i = n.filter((e) => e.action === "setJson");
        o(i);
      }
      o([]);
    },
    error: () => {
      t(new Error("Could not retrieve Adobe Target JSON Offer"));
    }
  }) : t(new Error("adobe API not defined"));
});
export {
  f as getAdobeTargetJsonOffer,
  a as getPropositions
};
